import { Popup } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { memo, useCallback } from 'react';

import { FundWalletPopupContent } from './components';
import { fundWalletPopupState as fundWalletPopupStateAtom } from './FundWalletPopup.states';

export const FundWalletPopup = memo(() => {
    const [fundWalletPopupState, setFundWalletPopupState] = useAtom(fundWalletPopupStateAtom);

    const toggleFundWalletPopupOpen = useCallback(
        (open: boolean) => {
            if (!open) {
                setFundWalletPopupState({});
            }
        },
        [setFundWalletPopupState]
    );

    return (
        <Popup open={Boolean(fundWalletPopupState.walletId)} onToggle={toggleFundWalletPopupOpen}>
            <FundWalletPopupContent />
        </Popup>
    );
});

FundWalletPopup.displayName = 'FundWalletPopup';
